import {redirectToLoginPage} from '../router/redirectToLoginPage';
import {getEnvironmentVars} from './open/getEnvironmentVars';

/**
 * Check every 5 minutes whether a user is still logged in.
 * If not, the user is redirected to the login page.
 */
export function initializeAuthCheck({userId}) {
  if (!userId) {
    return;
  }

  const fiveMinutes = 300000;
  setInterval(async () => {
    const envVars = await getEnvironmentVars();
    if (!envVars.userId) {
      setTimeout(() => redirectToLoginPage(), 1000);
      $.notify('Session has expired.', 'error');
    }
  }, fiveMinutes);
}
